import { trpc } from '@/shared/api/trpc';

// On success, refresh the reporter surfaces so a new ticket appears live: the
// drawer's My + Recent lists and the header unresolved-count badge.
export const useCreateTicket = () => {
  const utils = trpc.useUtils();
  return trpc.support.create.useMutation({
    onSuccess: () => {
      utils.support.myList.invalidate();
      utils.support.recentList.invalidate();
      utils.support.myUnresolvedCount.invalidate();
    },
  });
};
